export default __webpack_public_path__ + "static/media/geodoc-icon.40e1612f.svg";